import { gql } from "@apollo/client";

export const sendMailToProvider = gql(`
    mutation sendMailToProvider($args: SendMailToProvider!) {
      sendMailToProvider(args: $args)
    }
  `);
